@if (slides.enabled) {
  <app-button-group
    title="Themes"
    class="h-100 w-100"
    [(selectedValue)]="slides.active"
    >
    @for ($slide of slides.slides; track $slide) {
      <button
        [buttonGroupItem]="$index"
        class="slide-item heading-text fs-3"
        >
        <img class="theme-background" [themeSlideBackground]="$slide" alt="Theme Background">
        <div class="theme-title" [themeSlideTitle]="$slide">{{$slide.title}}</div>
      </button>
    }
  </app-button-group>
}
